import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { CookieService } from 'ngx-cookie-service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  private _upgradeURL: string;
  private _manageSubscriptionURL: string;
  private _currentFacility: FacilityObject = new FacilityObject();;

  constructor(private _httpClient: HttpClient,
    private _httpHeaderService: HttpHeadersService,
    private _cookieService: CookieService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _facilityService: FacilityService) { }


  public getTransactionPath(): Observable<any> {
    const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    return this._httpClient.get(environment.servicePath + '/maintenance/transaction', { headers });
  }

  private _getSubscriptionPath(): Observable<any> {
    const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    return this._httpClient.get(environment.servicePath + '/maintenance/manageSubscription', { headers });
  }


  public getToken(): void {       
    this._amplitudeAnalytics.logEvent({ 
      elementName: 'Subscription',
      action: 'Click'
    }, 'Subscription');
    this.getTransactionPath().subscribe(
      data => {
        this._upgradeURL = data.firebaseUrl;
        if (this._cookieService.get('vtImpersonatorTokenKey')) {
          this._upgradeURL += '&vtImpersonatorTokenKey=true';
        } else {
          this._upgradeURL += '&vtImpersonatorTokenKey=false';
        }
        this._getUpgradeURL();
      },
      error => {
        console.error('API failed.');
      }
    );
  }

  private _getUpgradeURL(): void {
    this._currentFacility = this._facilityService.selectedFacility();
    this._upgradeURL += '&sfac=' + this._currentFacility.facilityId;
    // if (this._currentFacility.summary.canUpgradeHalo === 'true') {
      window.location.href = this._upgradeURL;
    // }
  }

  public getJWTTokenFromAPI(userId : any, facilityId: any, product: any): Observable<any> {
    return this._httpClient.get(environment.servicePath 
      + '/maintenance/jwtToken?userId=' + userId 
      + '&facilityId=' + facilityId
      + '&product=' + product);
  }
 
}
